import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

const CreateCategoryModal = ({ show, onHide, onSubmit, loading }) => {
  const [formData, setFormData] = React.useState({
    name: '',
    description: '',
    status: 'active'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Frontend validation
    if (!formData.name || !formData.name.trim()) {
      toast.error('Category name is required');
      return;
    }
    
    if (formData.name.trim().length < 2) {
      toast.error('Category name must be at least 2 characters');
      return;
    }

    onSubmit(formData);
  };

  const handleClose = () => {
    setFormData({
      name: '',
      description: ''
    });
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Category</Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Category Name *</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter category name"
              value={formData.name}
              onChange={e => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData.description}
              onChange={e =>
                setFormData({ ...formData, description: e.target.value })
              }
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Saving...' : 'Add Category'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateCategoryModal;
